module.exports = __webpack_public_path__ + "static/media/icon_laptop_white.624c6288.svg";